import ProfilesIndex from "./ProfilesIndex";
export default ProfilesIndex;
